module.exports = __webpack_public_path__ + "images/help-selected112701de92ea9ba21410fbf62d28aa1a.png";